module.exports = __webpack_public_path__ + "img/t5-i3.d3d7fdb7.jpg";